export default __webpack_public_path__ + "static/media/logo frame (8).472f3fcb.png";